import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { PageTitle } from "../lib/ui";
import { Landmark, Receipt, FileText, FileSignature } from "lucide-react";

const TX = {
  es: { t: "¿Qué quieres subir?", s: "Elige el tipo de documento y te llevamos al flujo adecuado.",
    bank: "Extracto bancario", bankH: "Importa un CSV, Excel, PDF o foto de tu banco.",
    receipt: "Ticket o recibo", receiptH: "Haz una foto o sube la imagen de un gasto.",
    invoice: "Factura", invoiceH: "Crea una factura en Contratos y facturas.",
    contract: "Contrato", contractH: "Registra un contrato y sus vencimientos." },
  en: { t: "What do you want to upload?", s: "Choose the document type and we'll take you to the right flow.",
    bank: "Bank statement", bankH: "Import a CSV, Excel, PDF or photo from your bank.",
    receipt: "Ticket or receipt", receiptH: "Take a photo or upload an expense image.",
    invoice: "Invoice", invoiceH: "Create an invoice in Contracts & invoices.",
    contract: "Contract", contractH: "Register a contract and its due dates." },
  fr: { t: "Que voulez-vous importer ?", s: "Choisissez le type de document et on vous dirige vers le bon flux.",
    bank: "Relevé bancaire", bankH: "Importez un CSV, Excel, PDF ou une photo de votre banque.",
    receipt: "Ticket ou reçu", receiptH: "Prenez une photo ou importez l'image d'une dépense.",
    invoice: "Facture", invoiceH: "Créez une facture dans Contrats et factures.",
    contract: "Contrat", contractH: "Enregistrez un contrat et ses échéances." },
  pt: { t: "O que queres carregar?", s: "Escolhe o tipo de documento e levamos-te ao fluxo certo.",
    bank: "Extrato bancário", bankH: "Importa um CSV, Excel, PDF ou foto do teu banco.",
    receipt: "Talão ou recibo", receiptH: "Tira uma foto ou carrega a imagem de um gasto.",
    invoice: "Fatura", invoiceH: "Cria uma fatura em Contratos e faturas.",
    contract: "Contrato", contractH: "Regista um contrato e os seus vencimentos." },
  it: { t: "Cosa vuoi caricare?", s: "Scegli il tipo di documento e ti portiamo al flusso giusto.",
    bank: "Estratto conto", bankH: "Importa un CSV, Excel, PDF o foto della tua banca.",
    receipt: "Scontrino o ricevuta", receiptH: "Scatta una foto o carica l'immagine di una spesa.",
    invoice: "Fattura", invoiceH: "Crea una fattura in Contratti e fatture.",
    contract: "Contratto", contractH: "Registra un contratto e le sue scadenze." },
};

export default function UploadChooser() {
  const { locale, t } = useI18n();
  const L = TX[locale] || TX.es;
  const cards = [
    { id: "bank", to: "/import/universal", icon: Landmark, title: L.bank, help: L.bankH },
    { id: "receipt", to: "/capture", icon: Receipt, title: L.receipt, help: L.receiptH },
    { id: "invoice", to: "/contracts?new=invoice", icon: FileText, title: L.invoice, help: L.invoiceH },
    { id: "contract", to: "/contracts?new=contract", icon: FileSignature, title: L.contract, help: L.contractH },
  ];
  return (
    <div>
      <PageTitle title={L.t} subtitle={L.s} />
      <div className="grid gap-4 sm:grid-cols-2" data-testid="upload-chooser">
        {cards.map((c) => (
          <Link key={c.id} to={c.to} data-testid={`upload-card-${c.id}`}
            className="group flex items-start gap-4 bg-white border border-[#D5E7E5] rounded-xl p-5 hover:border-[#0299A0] hover:shadow-sm transition-colors">
            <span className="shrink-0 h-11 w-11 rounded-lg bg-[#0299A0]/10 text-[#0299A0] flex items-center justify-center group-hover:bg-[#0299A0] group-hover:text-white transition-colors">
              <c.icon size={22} strokeWidth={1.75} />
            </span>
            <span className="min-w-0">
              <b className="block text-[#075E62] text-base">{c.title}</b>
              <small className="block text-[#5F8588] mt-1">{c.help}</small>
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
